import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Question, QuestionOption } from "../../../../../types/dataModel";
import CommonTextEditor from "../../../../../core/common/textEditor";

interface Props {
  question?: Question;
  onSave: (question: Question) => void;
  onCancel: () => void;
  errorMessage?: string;
}

const EDITOR_TYPE = 'richText';

const RichTextQuestionEditor = ({ question, onSave, onCancel, errorMessage }: Props) => {
  const [formQuestion, setFormQuestion] = useState<Question>({
    questionText: undefined,
    options: []
  });

  useEffect(() => {
    if (question?.questionText) {
      setFormQuestion(question);
    } else if (question) {
      setFormQuestion({
        questionText: undefined,
        options: []
      });
    }
  }, [question]);

  const renderFormOption = (index: number, option: QuestionOption) => {
    return (
      <div key={index} className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2 gap-1">
          <div className="d-flex align-items-center  gap-1">
            <label className="text-dark fw-semibold">{index + 1}.</label>
            <div className="input-group-text gap-1 btn-soft-primary">
              <label className="fs-10 fw-semibold mt-1 text-primary">Correct? </label>
              <input className="form-check-input" type="checkbox"
                defaultChecked={option.isCorrect}
                onChange={(e) => {
                  let newOpts = [...formQuestion?.options || []]
                  newOpts[index].isCorrect = e.target.checked
                  setFormQuestion({
                    ...formQuestion,
                    options: [...newOpts]
                  })
                }} />
            </div>
          </div>
          <Link
            to="#"
            className="add-earnings d-flex justify-content-center text-danger"
            onClick={() => {
              let newOpts = [...formQuestion?.options || []]
              newOpts?.splice(index, 1)
              setFormQuestion({
                ...formQuestion,
                options: [...newOpts]
              })
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>

        <div className="input-group mb-2">
          <CommonTextEditor 
            id={`option-${formQuestion?.id || 'new'}-${index}`}
            key={`option-${formQuestion?.id || 'new'}-${index}`}
            defaultValue={option.optionText}
            onChange={(e) => {
                let newOpts = [...formQuestion?.options || []]
                newOpts[index].optionText = e.target.value
                  setFormQuestion({
                  ...formQuestion,
                  options: [...newOpts]
                })
            }}
            showSyntaxHelper={true}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <h4>{formQuestion?.id ? 'Edit Question' : 'Add New Question'}</h4>
            </div>
          </div>
        </div>

        {errorMessage && (
          <div className="alert alert-danger d-flex align-items-center mb-3">
            <i className="ti ti-alert-triangle me-2" />
            {errorMessage}
          </div>
        )}

        <form>
          <div className="row">
            <div className="col-12">
              <div className="mb-3">
                <label className="form-label mb-2">Enter Question</label>
                <CommonTextEditor
                  id={`question-text-editor`}
                  key={`${formQuestion?.id}-question` || `new-question`}
                  defaultValue={formQuestion?.questionText}
                  onChange={(e) => {
                    setFormQuestion({
                      ...formQuestion,
                      questionText: e.target.value,
                    })
                  }}
                  showSyntaxHelper={true}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="mb-0">
                <div className="d-flex justify-content-between mb-3">
                  <label className="form-label">Add New Option</label>
                  <Link
                    to=""
                    className="add-earnings text-primary mb-2"
                    onClick={(e: any) => {
                      e.preventDefault();
                      setFormQuestion({
                        ...formQuestion,
                        options: [
                          ...formQuestion?.options || [],
                          {
                            optionText: "",
                            isCorrect: false
                          }
                        ]
                      })
                    }}
                  >
                    <i className="ti ti-plus me-2" /> Add New
                  </Link>
                </div>
                {
                  formQuestion?.options?.map((option: QuestionOption, index: number) => {
                    return renderFormOption(index, option)
                  })
                }
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-light"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                onSave({
                  ...formQuestion,
                  options: formQuestion?.options?.map((option: QuestionOption, index: number) => {
                    return {
                      ...option,
                      displayOrder: index + 1
                      }
                    }) || [],
                  metadata: {
                    editorType: EDITOR_TYPE
                  }
                })  
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RichTextQuestionEditor;

